export default __webpack_public_path__ + "static/media/NextProject3.e67ab7dc.png";